import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AbilityService } from 'ability';
import { PermissionsEnum, RoutingPath } from 'mbs-ui-shared';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class LicensesGuard implements CanActivate {
  constructor(private auth: AuthFacade, private router: Router, private ability: AbilityService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.currentUser$.pipe(
      switchMap((user) => {
        const isPostPayment = user.ProviderInfo?.IsPostPayment;

        const url = state.url.split('?')[0];

        if (url === RoutingPath.ApLicensesAspx && isPostPayment) {
          void this.router.navigate([RoutingPath.ApLicenses]);
        }

        if (url === RoutingPath.ApLicenses && !isPostPayment && this.ability.cannot('read', PermissionsEnum.AllowPrePaymentLicensePage)) {
          void this.router.navigate([RoutingPath.ApLicensesAspx], { queryParams: next.queryParams });
        }

        return of(true);
      })
    );
  }
}
